import { ChevronDown } from 'lucide-react';
import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from './cn';
import { controlStyles, type ControlSize } from './controlStyles';
import { useFieldControl } from './fieldContext';

export interface SelectProps extends Omit<
  SelectHTMLAttributes<HTMLSelectElement>,
  'size'
> {
  controlSize?: ControlSize;
  /** Classes for the wrapper; set widths here (`containerClassName="w-40"`). */
  containerClassName?: string;
}

/**
 * Styled native `<select>` for forms and settings. For choosing an action,
 * use `DropdownMenu`; for two to four visible options, `SegmentedControl`.
 */
export const Select = /* @__PURE__ */ forwardRef<
  HTMLSelectElement,
  SelectProps
>(function Select(
  { controlSize = 'md', containerClassName, className, children, ...props },
  ref
) {
  const controlProps = useFieldControl(props);
  return (
    <div className={cn('relative', containerClassName)}>
      <select
        ref={ref}
        className={controlStyles({
          size: controlSize,
          className: cn(
            'cursor-pointer appearance-none truncate',
            controlSize === 'sm' ? 'pr-8' : 'pr-9',
            className
          ),
        })}
        {...controlProps}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden="true"
        className={cn(
          'pointer-events-none absolute top-1/2 size-4 -translate-y-1/2 text-fg-muted',
          controlSize === 'sm' ? 'right-2' : 'right-2.5'
        )}
      />
    </div>
  );
});
